import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

/** Shown in place of a screen that is switched off (see lib/features.js). */
export function FeatureUnavailable({ title, reason }) {
  return (
    <div className="space-y-6" data-testid="feature-unavailable">
      <h1 className="text-3xl font-bold text-foreground">{title}</h1>
      <Card>
        <CardContent className="py-10 text-center space-y-3">
          <p className="font-medium">{title} is not available yet.</p>
          {reason && <p className="text-sm text-muted-foreground max-w-xl mx-auto">{reason}</p>}
          <Button variant="outline" asChild>
            <Link to="/analytics">Go to Analytics</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default FeatureUnavailable;
